import React, { useContext } from 'react';
import Box from '@material-ui/core/Box';
import MomentUtils from '@date-io/moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { CalendarEditAvailabilityContext } from '../../Context';

const useStyles = makeStyles(() => ({
  dateTile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiPickersDay-daySelected': {
      background: '#296690',
    },
  },
  dateHasSchedule: {
    '& .MuiPickersDay-day': {
      background: '#BAE2E7',
      color: '#000000',
    },
    '& .MuiPickersDay-daySelected': {
      border: '3px solid #296690',
      height: '30px',
      width: '30px',
    },
  },
  dateHasException: {
    '& .MuiPickersDay-day': {
      background: '#F39D9D',
      color: '#000000',
    },
    '& .MuiPickersDay-daySelected': {
      border: '3px solid #296690',
      height: '30px',
      width: '30px',
    },
  },
}));

const AvailabilityCalendar = () => {
  const { handleMonthChange, selectedDate, handleSelectDate } = useContext(
    CalendarEditAvailabilityContext,
  );

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DatePicker
        autoOk
        variant="static"
        openTo="date"
        onMonthChange={handleMonthChange}
        value={selectedDate}
        onChange={handleSelectDate}
        disableToolbar
        renderDay={(day, selectDate, isInCurrentMonth, dayComponent) => (
          <AvailabilityCalendarDay day={day} dayComponent={dayComponent} />
        )}
      />
    </MuiPickersUtilsProvider>
  );
};

export default AvailabilityCalendar;

const AvailabilityCalendarDay = ({ day, dayComponent }) => {
  const {
    scheduleData,
    scheduleExceptions,
    showExceptionsOnCalendar,
    showAvailabilityOnCalendar,
  } = useContext(CalendarEditAvailabilityContext);
  const classes = useStyles();

  const isException = scheduleExceptions.find((val) =>
    moment(val.start_time).isSame(day, 'day'),
  );
  const hasScheduleInstance = scheduleData.find((val) =>
    moment(val.start_time).isSame(day, 'day'),
  );
  if (isException && showExceptionsOnCalendar) {
    return <Box className={classes.dateHasException}>{dayComponent}</Box>;
  }
  if (hasScheduleInstance && showAvailabilityOnCalendar) {
    return <Box className={classes.dateHasSchedule}>{dayComponent}</Box>;
  }
  return <Box className={classes.dateTile}>{dayComponent}</Box>;
};
